import { FormattedMessage } from 'react-intl';
import ScreenshotDialog from './ScreenshotDialog';
import Button from '@rio-cloud/rio-uikit/Button';
import CreateStepTwo from '../createPartnerDialog/CreateStepTwo';
import { useForm } from 'react-hook-form';
import type { FormEmailData } from '../createPartnerDialog/CreatePartnerDialog';
import { ConnectionTypes } from '../../services/partnerNetwork.types';
import { useRestrictConnection } from '../../routes/routeHooks';

const ScreenshotOfShareInvitationLink = () => {
    const connectionType = useRestrictConnection() ?? ConnectionTypes.ORDER_EXCHANGE;

    const emailForm = useForm<FormEmailData>({
        mode: 'onSubmit',
    });

    return (
        <ScreenshotDialog
            title={<FormattedMessage id='intl-msg:network.addPartner.step1.title' />}
            buttons={
                <div className='btn-toolbar justify-content-end'>
                    <button className='btn btn-default' type='button'>
                        <span className='rioglyph rioglyph-link' />
                        <FormattedMessage id='intl-msg:network.addPartner.copyInvitationLink' />
                    </button>
                    <Button type='submit' className='btn btn-primary'>
                        <span className='rioglyph rioglyph-envelope' />
                        <FormattedMessage id='intl-msg:network.label.sendEmailInvitation' />
                    </Button>
                </div>
            }
        >
            <CreateStepTwo form={emailForm} connectionType={connectionType} />
        </ScreenshotDialog>
    );
};
export default ScreenshotOfShareInvitationLink;
